import { useEffect, useRef } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import QuizWidget from '@/components/feature/QuizWidget';

export default function QuizSection() {
  const { ref, revealed } = useScrollReveal();
  const sectionRef = useRef<HTMLElement>(null);

  const tryScrollToQuiz = () => {
    if (window.location.hash === '#quiz' && sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Scroll into view on mount or when hash changes
  useEffect(() => {
    const t = setTimeout(tryScrollToQuiz, 120);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const onHashChange = () => tryScrollToQuiz();
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  return (
    <section
      id="quiz"
      ref={sectionRef}
      className="py-20 md:py-28 bg-background-100 scroll-mt-[72px]"
    >
      <div
        ref={ref}
        className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}
      >
        <QuizWidget />
      </div>
    </section>
  );
}